import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type TabStateEntry<T = any> = {
  data: T
  scrollPositions?: Record<string, number>
  lastUpdated: number
}

type TabsState = {
  entries: Record<string, TabStateEntry<any>>
}

const initialState: TabsState = { entries: {} }

const tabStateSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setTabState: (state, action: PayloadAction<{ key: string; data: any }>) => {
      const { key, data } = action.payload
      state.entries[key] = { data, lastUpdated: Date.now(), scrollPositions: state.entries[key]?.scrollPositions }
    },
    setScrollPositions: (state, action: PayloadAction<{ key: string; scrollPositions: Record<string, number> }>) => {
      const { key, scrollPositions } = action.payload
      const prev = state.entries[key]
      state.entries[key] = { data: prev?.data ?? {}, lastUpdated: Date.now(), scrollPositions }
    },
    clearTabState: (state, action: PayloadAction<{ key: string }>) => {
      const { key } = action.payload
      delete state.entries[key]
    },
    clearAllTabStates: (state) => {
      state.entries = {}
    },
  },
})

export const { setTabState, setScrollPositions, clearTabState, clearAllTabStates } = tabStateSlice.actions
export default tabStateSlice.reducer
